<div class="container">
    <div class="project-progress-container" [ngClass]="{ isHistoryExpanded: showExtra }">
        <tam-progress [nodes]="progressData" (widthChanged)="onProgressWidthChanged($event)"
            (nodeClicked)="onProgressNodeClicked($event)" [isExpanded]="initialProgressExpansionState"></tam-progress>
    </div>
    <div class="task-container">
        <div class="detail-header">
            <span class="task-name text-ellipsis">{{ task.name }}</span>
            <span class="close-icon" (click)="onClickCancel($event)">
                <smart-icon name="close" class="light"></smart-icon>
            </span>
        </div>
        <div class="task-description" *ngIf="taskDescription">
            {{ taskDescription }}
        </div>
        <div class="detail-body" loading-spin [isLoading]="isLoading" [loadingSize]="'big'" [ngClass]="{
                'detail-body-has-footer': buttons && buttons.length,
                'detail-body-no-footer': !buttons || buttons.length === 0,
                'is-top-border-visible': !taskDescription
            }">
            <div class="fields-area" *ngIf="!isLoading && task.taskDefinition.template">
                <div class="template-row" *ngFor="let row of task.taskDefinition.template.contains">
                    <div class="one-control" [style.width]="item.width + '%'" *ngFor="let item of row"
                        [ngSwitch]="item.type" attr.tid="{{
                            item.label || item.field.fieldDefinition.name
                        }}">
                        <tam-entity-field *ngSwitchCase="'multiEntityDropdown'" [config]="item">
                        </tam-entity-field>
                        <tam-date-field *ngSwitchCase="'date'" [config]="item" viewMode="full"></tam-date-field>
                        <tam-file-field *ngSwitchCase="'file'" [config]="item"></tam-file-field>
                        <tam-single-text-dropdown-field *ngSwitchCase="'singleTextDropdown'" [config]="item">
                        </tam-single-text-dropdown-field>
                        <tam-text-field *ngSwitchCase="'text'" [config]="item" viewMode="full">
                        </tam-text-field>
                        <tam-single-entity-dropdown-field *ngSwitchCase="'singleEntityDropdown'" [config]="item"
                            [valueChangeSubject]="valueChangeSubject" [instance]="instance">
                        </tam-single-entity-dropdown-field>
                        <tam-number-field *ngSwitchCase="'number'" [config]="item">
                        </tam-number-field>
                        <tam-text-area-field *ngSwitchCase="'textArea'" [config]="item">
                        </tam-text-area-field>
                        <tam-rich-editor-field *ngSwitchCase="'richEditor'" [config]="item" viewMode="“full”">
                        </tam-rich-editor-field>
                        <tam-check-list-field *ngSwitchCase="'checkList'" [config]="item" viewMode="fullWithoutBorder">
                        </tam-check-list-field>
                        <tam-single-user-dropdown-field *ngSwitchCase="'singleUserDropdown'" [config]="item">
                        </tam-single-user-dropdown-field>
                        <tam-temp-other *ngSwitchDefault [config]="item"></tam-temp-other>
                    </div>
                </div>
            </div>
            <div class="fields-area" *ngIf="!isLoading && !task.taskDefinition.template">
                <div class="one-detail" *ngFor="let keyValue of fields | keyvalue"
                    attr.tid="{{ keyValue.value.label }}">
                    <div [ngSwitch]="keyValue.value.type">
                        <tam-entity-field *ngSwitchCase="'multiEntity'" [config]="keyValue.value"></tam-entity-field>
                        <tam-date-field *ngSwitchCase="'date'" [config]="keyValue.value" viewMode="full">
                        </tam-date-field>
                        <tam-file-field *ngSwitchCase="'file'" [config]="keyValue.value"></tam-file-field>
                        <tam-single-text-dropdown-field *ngSwitchCase="'singleTextDropdown'" [config]="keyValue.value">
                        </tam-single-text-dropdown-field>
                        <tam-text-field *ngSwitchCase="'text'" [config]="keyValue.value" viewMode="full">
                        </tam-text-field>
                        <tam-single-entity-dropdown-field *ngSwitchCase="'singleEntityDropdown'"
                            [config]="keyValue.value">
                        </tam-single-entity-dropdown-field>
                        <tam-number-field *ngSwitchCase="'number'" [config]="keyValue.value">
                        </tam-number-field>
                        <tam-text-area-field *ngSwitchCase="'textArea'" [config]="keyValue.value">
                        </tam-text-area-field>
                        <tam-rich-editor-field *ngSwitchCase="'richEditor'" [config]="keyValue.value" viewMode="full">
                        </tam-rich-editor-field>
                        <tam-check-list-field *ngSwitchCase="'checkList'" [config]="keyValue.value"
                            viewMode="fullWithoutBorder">
                        </tam-check-list-field>
                        <tam-single-user-dropdown-field *ngSwitchCase="'singleUserDropdown'" [config]="keyValue.value">
                        </tam-single-user-dropdown-field>
                        <tam-temp-other *ngSwitchDefault [config]="keyValue.value"></tam-temp-other>
                    </div>
                </div>
            </div>
            <div class="former-fields-area" *ngIf="!isLoading && task.taskDefinition.type === 'approval'">
                <div class="one-task-detail" *ngFor="let previousTask of previousTasks; index as i">
                    <div class="fields-area" *ngIf="previousTask.taskDefinition.template">
                        <div class="template-row" *ngFor="
                                let row of previousTask.taskDefinition.template
                                    .contains
                            ">
                            <div class="one-control" [style.width]="item.width + '%'" *ngFor="let item of row"
                                [ngSwitch]="item.type" attr.tid="{{
                                    item.label ||
                                        item.field.fieldDefinition.name
                                }}">
                                <tam-entity-field *ngSwitchCase="'multiEntityDropdown'" [config]="item">
                                </tam-entity-field>
                                <tam-date-field *ngSwitchCase="'date'" [config]="item" viewMode="full"></tam-date-field>
                                <tam-file-field *ngSwitchCase="'file'" [config]="item"></tam-file-field>
                                <tam-single-text-dropdown-field *ngSwitchCase="'singleTextDropdown'" [config]="item">
                                </tam-single-text-dropdown-field>
                                <tam-text-field *ngSwitchCase="'text'" [config]="item" viewMode="full">
                                </tam-text-field>
                                <tam-single-entity-dropdown-field *ngSwitchCase="'singleEntityDropdown'"
                                    [config]="item">
                                </tam-single-entity-dropdown-field>
                                <tam-number-field *ngSwitchCase="'number'" [config]="item">
                                </tam-number-field>
                                <tam-text-area-field *ngSwitchCase="'textArea'" [config]="item">
                                </tam-text-area-field>
                                <tam-rich-editor-field *ngSwitchCase="'richEditor'" [config]="item"
                                    borderMode="“outerBorder”">
                                </tam-rich-editor-field>
                                <tam-check-list-field *ngSwitchCase="'checkList'" [config]="item"
                                    viewMode="fullWithoutBorder">
                                </tam-check-list-field>
                                <tam-single-user-dropdown-field *ngSwitchCase="'singleUserDropdown'" [config]="item">
                                </tam-single-user-dropdown-field>
                                <tam-temp-other *ngSwitchDefault [config]="item"></tam-temp-other>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="detail-footer">
            <div #anchor class="extra-div-for-popup">
                <button tam-button *ngFor="let item of buttons; index as i" [tamType]="item.type" [tamSize]="item.size"
                    [disabled]="
                        item.disable ||
                        (fileOperating && i !== 0 && item) ||
                        buttonOperating
                    " (click)="item.onClick($event, item)">
                    {{ item.text }}
                </button>
            </div>
        </div>
        <kendo-popup [anchor]="anchor" [style.display]="showPopup ? '' : 'none'"
            [anchorAlign]="{ horizontal: 'right', vertical: 'bottom' }"
            [popupAlign]="{ horizontal: 'right', vertical: 'bottom' }">
            <div class="list-area" *ngIf="showListInPopup">
                <kendo-dropdownlist [filterable]="false" [data]="backTaskList" [textField]="'name'" [valueField]="'id'"
                    [value]="backTask" [popupSettings]="{ appendTo: 'component' }"
                    (valueChange)="onChangeBackTask($event)">
                </kendo-dropdownlist>
            </div>
            <div class="comment-container" [ngClass]="{ 'no-dropdown-on-top': !showListInPopup }">
                <div class="text-area" [ngClass]="{ 'no-dropdown-on-top': !showListInPopup }">
                    <textarea maxlength="500" #commentArea [(ngModel)]="comment"
                        [placeholder]="popupPlaceholder"></textarea>
                </div>
                <div class="function-area">
                    <div class="text-info">{{ comment.length }}/500</div>
                    <div class="button-area">
                        <button tam-button *ngFor="let item of commentButtons" [tamType]="item.type"
                            [tamSize]="item.size" [disabled]="item.disable" (click)="item.onClick($event)">
                            {{ item.text }}
                        </button>
                    </div>
                </div>
            </div>
        </kendo-popup>
        <smart-icon *ngIf="!showExtra" name="layout-collapse" class="toggle-icon"
            (click)="showExtraInformation($event)"></smart-icon>
    </div>
    <div class="extra-container" *ngIf="showExtra">
        <smart-icon name="layout-expand" class="toggle-icon" (click)="showExtraInformation($event)"></smart-icon>
        <div class="tabs-area">
            <tam-tab-set [selectedIndex]="selectedIndex" (selectChange)="selectChange($event)">
                <tam-tab *ngFor="let item of tabsData" [title]="item.title" [editable]="item.editable"></tam-tab>
            </tam-tab-set>
        </div>
        <div class="tab-area">
            <instance-task-timeline *ngIf="selectedIndex === 0" [instance]="instance"></instance-task-timeline>
            <tam-instance-comments *ngIf="selectedIndex === 1" [instance]="instance">Comments</tam-instance-comments>
        </div>
    </div>
</div>